import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { InstrumentContext } from "../../providers/InstrumentContextProvider";
import { Tabs } from "antd";

import { IconArg, IconGlobal } from "../Icons";
import ProductsTableTabContent from "./ProductsTableTabContent";
import IndexesTable from "../Tables/IndexesTable";

export default function NestedTabs({ currentInstrument, instruments }) {
    const navigate = useNavigate();
    const { setInstrumentName } = useContext(InstrumentContext);
    const firstLevelNav = [
        {
            key: "argentina",
            label: "Argentina",
            icon: <IconArg />,
            children: <ProductsTableTabContent currentInstrument={currentInstrument} items={instruments} />,
        },
        {
            key: "indices",
            label: "Índices",
            icon: <IconGlobal />,
            children: <IndexesTable />,
        },
    ];

    return (
        <div className="cot-nested-tabs">
            <Tabs
                defaultActiveKey={currentInstrument === "indices" ? "indices" : "argentina"}
                items={firstLevelNav}
                onChange={key => {
                    setInstrumentName(key === "indices" ? "Índices" : "Acciones");
                    navigate(`/${key === "indices" ? "indices" : "acciones"}/`, { replace: true });
                }}
            />
        </div>
    );
}
